import { useWallet, WalletType } from "@/providers/wallet";

import Input from "@/ui/input";
import { useState } from "react";
import CheckBtn from "./check-btn";

export const ImportWallet = ({ walletType }: { walletType: WalletType }) => {
  const [privateKey, setPrivateKey] = useState("");
  const { onImportWallet } = useWallet();

  const handleImportWallet = () => {
    if (!privateKey || privateKey === "") {
      return;
    }
    onImportWallet(privateKey, walletType);
    setPrivateKey("");
  };
  return (
    <div className="flex flex-row items-center gap-[0.3125rem]">
      <div className="text-white text-xs w-[7rem]">Import Wallet:</div>
      <div className="w-[25rem] h-[1.375rem]">
        <Input
          onChange={(value) => setPrivateKey(value)}
          value={privateKey}
          placeholder="Private Key"
        />
      </div>
      <CheckBtn onClick={handleImportWallet} />
    </div>
  );
};

export default ImportWallet;
